"use client"
import { useLayoutEffect, useRef } from "react"

// In React 19, <title> elements are automatically hoisted to <head> on every
// React commit, which resets document.title to the root layout default ("Scoreach")
// after every re-render. useLayoutEffect (no deps) runs synchronously after each
// commit and overrides the hoist, so the correct title always wins.
export function usePageTitle(title: string) {
  const ref = useRef(title)
  ref.current = title

  useLayoutEffect(() => {
    document.title = ref.current ? `${ref.current} | Scoreach` : "Scoreach"
  })
}
